export default __webpack_public_path__ + "static/media/model-x.25937b94.jpg";